<nav class="navigation-container"
     [class.show]="!isLoginPage">
  <app-navigation />
</nav>

<main class="main-container"
      [class.login-page]="isLoginPage">
  <router-outlet />
</main>

<p-toast />
